import React, { useEffect, useState } from 'react'
import { getEmployeeResultwithAdminToken } from '../../../services/api-services';
import FinalAssesmentsubmitionModal from '../comman/finalAssesmentsubmitionModal';
import MaturityScalepreviewall from '../../../user/pages/page/MaturityScalepreviewall';
import SmallBarChartPreviewall from '../../../user/pages/page/smallBarChartPreviewall';
import AdminTesteftbar from '../comman/adminTesteftbar';
import { API_RESPONSE } from '../../../utills/app-constant';
import { toastEmitter } from '../../../utills/utilities';

const PreviewAllAdminAns = ({ CampaignData, parsedEmployeeData, handleaddAnswer, setShowPreview, finalAssesmentModal, setFinalAssesmentModal, submitBtnDisable, backBtnDisable }) => {

    const [highlightId, setHighlightId] = useState(null);
    const [loader, setLoader] = useState(true);
    const [questionAnswer, setquestionAnswer] = useState([]);
    const levelMapping = {
        Initiating: 1,
        Emerging: 2,
        Performing: 3,
        Advancing: 4,
        Leading: 5,
    };

    useEffect(() => {
        const handleHighlight = (e) => {
            setHighlightId(e.detail);   // highlight stays until new click
        };

        window.addEventListener("highlight-question", handleHighlight);
        return () => window.removeEventListener("highlight-question", handleHighlight);
    }, []);

    const getAnsQus = async (id) => {
        setLoader(true)
        try {
            const response = await getEmployeeResultwithAdminToken(CampaignData?.assessorCampaignResponse?.campaignId, CampaignData?.assessorCampaignResponse?.companyAssessorId, CampaignData?.assessorCampaignResponse?.modelId);
            if (response?.data?.responseCode === 200 || response?.data?.responseCode == "SUCCESS") {
                const modifiedQuestionAnswer = response?.data?.data?.questionResponseList?.map(question => {
                    const optionValues = question.optionResponseList?.map(option => option.value);
                    return {
                        ...question,
                        optionResponseList: optionValues, // replace the original optionResponseList with the transformed array
                    };
                });
                setquestionAnswer(modifiedQuestionAnswer)
                //   setRemark(response?.data?.data?.remark)
                setLoader(false)
            } else {
                setLoader(false)
            }
        } catch (err) {
            setLoader(false)
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
        }
    }


    useEffect(() => {
        getAnsQus(parsedEmployeeData?.id);
    }, [])

    return (
        <>
            <div>
                <div className='preview-sec'>
                    <button disabled={backBtnDisable} className='resultpublishbtn px-3 mb-0' onClick={() => setShowPreview(false)}> Back to Answers</button>
                    <button disabled={submitBtnDisable} className='quiznextbtn px-3' onClick={() => handleaddAnswer("Submit", setFinalAssesmentModal)}>Definitely Submit</button>
                </div>

                {loader ? <>
                    <div className='loader-user'> <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div></div>
                </> : <><div className="row m-0">
                    {/* LEFT SIDEBAR */}
                    <div className="col-3 p-0">
                        <AdminTesteftbar
                            CampaignData={CampaignData}
                            parsedEmployeeData={parsedEmployeeData}
                            pageName="previewleftbar"
                            onSelectQuestion={(questionId) => {
                                const el = document.getElementById(`question-${questionId}`);
                                if (el) {
                                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                                }
                            }}
                        />
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="col-9 p-0">
                        <div className='user_profile_intro_right'>
                            {questionAnswer?.map((data, i) => {
                                const importantLevel = levelMapping[data?.important] || 0;
                                return (
                                    <div
                                        key={data?.id}
                                        id={`question-${data?.id}`}   // ← USE API ID
                                        className={`row m-0 ${i === 0 ? "mt-5" : "mt-1"}`}
                                    >
                                        <div className="col-md-12">
                                            <div
                                                id={`question-${data?.id}`}
                                                className={`result_top_section ${i === 0 ? "mt-5" : "mt-1"} 
                                                ${highlightId === data?.id ? "result_highlight" : ""}`}
                                            >
                                                <p>{i + 1}) {data?.question}</p>

                                                <div className="row">
                                                    <div className="col-md-3 text-center">
                                                        <SmallBarChartPreviewall
                                                            value={importantLevel}
                                                            maturityScales={false}

                                                        />
                                                    </div>

                                                    <div className="col-md-9">
                                                        <MaturityScalepreviewall
                                                            currentLevel={data?.current}
                                                            targetLevel={data?.future}
                                                            optionLabel={true}
                                                        />
                                                    </div>
                                                </div>

                                                {data?.comment && (
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <h5 className="small_bar_chart">Comment:</h5>
                                                            <p>{data?.comment}</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div></>}





                <FinalAssesmentsubmitionModal finalAssesmentModal={finalAssesmentModal} setFinalAssesmentModal={setFinalAssesmentModal} type="admin" />
            </div>
        </>
    )
}

export default PreviewAllAdminAns
